import { Controller } from '@hotwired/stimulus';

const loadingMarkup = '<div class="fixed top-0 right-0 bottom-0 left-0 bg-transparent z-[100]"></div><style>.turbo-progress-bar { visibility: hidden; }</style>';

export default class BlockingLoadingIndicatorController extends Controller {
  static targets = ['observedForm', 'loadingIndicator'];

  initialize() {
    this.loadingStartListener = this.loadingStart.bind(this);
    this.loadingEndListener = this.loadingEnd.bind(this);
    this.loadingElement = document.createElement('div');
    this.loadingElement.innerHTML = loadingMarkup;
  }

  observedFormTargetConnected(element) {
    element.addEventListener('turbo:submit-start', this.loadingStartListener);
    element.addEventListener('turbo:submit-end', this.loadingEndListener);
  }

  observedFormTargetDisconnected(element) {
    element.removeEventListener('turbo:submit-start', this.loadingStartListener);
    element.removeEventListener('turbo:submit-end', this.loadingEndListener);
  }

  loadingStart() {
    this.element.classList.add('blocking-loading-active');
    this.element.appendChild(this.loadingElement);
    this.loadingIndicatorTargets.forEach((element) => element.classList.remove('hidden'));
  }

  loadingEnd() {
    this.element.classList.remove('blocking-loading-active');
    this.element.removeChild(this.loadingElement);
    this.loadingIndicatorTargets.forEach((element) => element.classList.add('hidden'));
  }
}
